'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimulationContentModel = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class;

var _mobx = require('mobx');

var _contentmodel = require('./contentmodel.js');

var _contentmodel2 = _interopRequireDefault(_contentmodel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SimulationContentModel = exports.SimulationContentModel = (_dec = _mobx.action.bound, (_class = function (_ContentModel) {
  (0, _inherits3.default)(SimulationContentModel, _ContentModel);

  function SimulationContentModel() {
    (0, _classCallCheck3.default)(this, SimulationContentModel);
    return (0, _possibleConstructorReturn3.default)(this, (SimulationContentModel.__proto__ || (0, _getPrototypeOf2.default)(SimulationContentModel)).apply(this, arguments));
  }

  (0, _createClass3.default)(SimulationContentModel, [{
    key: 'exportToServer',
    value: function exportToServer(cb, errCb) {

      if (this.anyDirty) return console.warn("cannot publish while dirty, please save");

      if (!this.readyToWriteToServer) {
        // save normally
        throw new Error("not ready to write to server!");
      }

      if (this.isSaving || this.isPublishing) return console.warn("already saving...");

      // so we know when this "isSaving"
      this.willPublish = +new Date();
      var ref = this.lastPublished;
      this.lastPublished = +new Date();

      this._saveEntity(cb, errCb);
    }
  }]);
  return SimulationContentModel;
}(_contentmodel2.default), (_applyDecoratedDescriptor(_class.prototype, 'exportToServer', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'exportToServer'), _class.prototype)), _class));
var _default = SimulationContentModel;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SimulationContentModel, 'SimulationContentModel', 'src/entity_modules/simulation-entity/contentmodel.localmode.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/simulation-entity/contentmodel.localmode.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/entity_modules/simulation-entity/contentmodel.localmode.js
// module id = ./node_modules/platform-client-bootstrap/dist/entity_modules/simulation-entity/contentmodel.localmode.js
// module chunks = 0